import axios from "axios";
var ActivityUrl = "animal/activity-log";
export default {
  async registerAnimal(data) {
    return await axios
      .post("/animal", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async uploadAnimals(data) {
    console.log(data)
    return await axios.post('animal/import', data)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },

  async getAnimals(type, dataOptions, search = "", source = "", farm = '') {
    const { sortBy, sortDesc, page, itemsPerPage } = dataOptions;
    var url = `animal/?page=${page}&limit=${itemsPerPage}&list=${type}&source=${source}`;
    if (search != "") url = `${url}&search=${search}`;
    if (sortBy&&sortBy.length === 1 && sortDesc&sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
    if(farm.length)
      url = `${url}&farm=${farm}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAnimalForAssigningGroup(dataOptions, search = "", filterParams = {}, excludedAnimals = []) {
    const { sortBy, sortDesc, page, itemsPerPage } = dataOptions;
    let url = `animal/for-assigning-group?page=${page}&limit=${itemsPerPage}`;
    const { status,
      trait,
      dateFrom,
      dateTo,
      birthDateFrom,
      birthDateTo,
      birthWeigthMin,
      birthWeigthMax,
      weaningWeightMin,
      weaningWeightMax,
      yearningWeightMin,
      yearningWeigthMax,
      carcassWeigthMin,
      carcassWeigthMax,
      sortByA
    } = filterParams;
    if (status) {
      url += `&status=${status}`
    }
    if (trait) {
      url += `&trait=${trait}`
    }
    if (dateFrom) {
      url += `&dateFrom=${dateFrom}`
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`
    }
    if (birthDateFrom) {
      url += `&birthDateFrom=${birthDateFrom}`
    }
    if (birthDateTo) {
      url += `&birthDateTo="${birthDateTo}`
    }
    if (birthWeigthMin) {
      url += `&birthWeigthMin=${birthWeigthMin}`
    }
    if (birthWeigthMax) {
      url += `&birthWeigthMax=${birthWeigthMax}`
    }
    if (weaningWeightMin) {
      url += `&weaningWeightMin=${weaningWeightMin}`
    }
    if (weaningWeightMax) {
      url += `&weaningWeightMax=${weaningWeightMax}`
    }
    if (yearningWeightMin) {
      url += `&yearningWeightMin=${yearningWeightMin}`
    }
    if (yearningWeigthMax) {
      url += `&yearningWeigthMax=${yearningWeigthMax}`
    }
    if (carcassWeigthMin) {
      url += `&carcassWeigthMin=${carcassWeigthMin}`
    }
    if (carcassWeigthMax) {
      url += `&carcassWeigthMax=${carcassWeigthMax}`
    }
    if (sortByA) {
      url += `&sortBy=${sortByA}`
    }
    if (search != "") url = `${url}&search=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;
    return await axios
      .post(url, { excludedAnimals })
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async assignAnimalToGroup(excludeAnimals = []) {
    var url = `animal/assignGroup`;
    return await axios
      .post(url, { excludeAnimals })
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async resendAnimalsToUser(resendAnimals = []) {
    var url = `animal/resend-to-user`;
    return await axios
      .put(url, { resendAnimals })
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async getManageAnimalStage() {
    var url = `animal/log-step`;
    return await axios
      .get(url,)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async updateStage(stage) {
    var url = `animal/log-step`;
    return await axios
      .put(url, { stage })
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async getUngrouppedAnimals(dataOptions, search) {
    const { sortBy, sortDesc, page, itemsPerPage } = dataOptions;
    var url = `animalGenetics/list?tab=ungrouped&user=all&page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&searchPhrase=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&sortCol=${sortBy[0]}&sortOrder=${sortDesc[0]?'DESC':'ASC'}`;


    return await axios
      .get(url,)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getSingleAnimal(animalId, source='') {
    var url = `animal/${animalId}?source=${source}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimal(animalData, source='') {
    var url = `animal?source=${source}`;
    return axios
      .put(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAnimalPerformance(animalId) {
    var url = `animal/performance/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async updateAnimalPerformance(animalData, alreadyRegistered) {
    var url = `animal/performance`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },

  async getAnimalSectionDate(section, animalId, tab = "", data, search = "") {
    const { sortBy, sortDesc, page, itemsPerPage } = data;
    var url = `animal/${section}/${animalId}`;
    if (tab.length) url = `${url}/${tab}`;
    url = `${url}?page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&search=${search}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;

    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAllAnimalSectionData(section, tab = "", data) {
    const { sortBy, sortDesc, page, itemsPerPage } = data;
    var url = `animal/${section}`;
    if (tab.length) url = `${url}/${tab}`;
    url = `${url}?page=${page}&limit=${itemsPerPage}`;
    if (sortBy.length === 1 && sortDesc.length === 1)
      url = `${url}&col=${sortBy[0]}&desc=${sortDesc[0]}`;

    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async registerAnimalConception(animalData) {
    var url = `animal/conception`;

    return axios
      .post(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async searchSire(search) {
    var url = `option/animal/sire?limit=7&search=${search}`;
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAnimalHealthRecord(animalId) {
    var url = `animal/healthrecord/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalHealthRecord(animalData, alreadyRegistered) {
    var url = `animal/healthrecord`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },

  async getAnimalGenotypeData(animalId) {
    var url = `animal/genotype/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalGenotypeData(animalData, alreadyRegistered) {
    var url = `animal/genotype`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },

  async getAnimalGenworth(animalId) {
    var url = `animal/geneticworth/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalGenworth(animalData, alreadyRegistered) {
    var url = `animal/geneticworth`;
    if (alreadyRegistered) return axios.put(url, animalData);
    else
      return axios
        .post(url, animalData)
        .then(({ data }) => data)
        .catch((error) => {
          return Promise.reject(error.response);
        });
  },
  async getActivityLogs(dataOptions, animalNumber, search = "") {
    const { page, itemsPerPage } = dataOptions;
    var url = `${ActivityUrl}/${animalNumber}?page=${page}&limit=${itemsPerPage}`;
    if (search != "") url = `${url}&search=${search}`;

    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async getNotes(animalId) {
    var url = `animal/note/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  async createNote(noteData) {
    return await axios
      .post("animal/note", noteData)
      .then(({ data }) => data)
      .catch((err) => err);
  },
  async updateAnimalImage(data) {
    return await axios
      .put("/animal/image", data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async searchAnimal(search = "") {
    console.log(search)
    var url = "/option/animal/list?page=1&limit=1000";
    if (search.length > 0) url = `${url}&search=${search}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error));
  },

  async getFeedRecords(dataOptions, animalNumber, search = "") {
    const { page, itemsPerPage } = dataOptions;
    var url = `animal/feed?page=${page}&limit=${itemsPerPage}&animal=${animalNumber}`;
    if (search != "") url = `${url}&search=${search}`;

    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async registerFeed(data) {
    var url = `animal/feed`;
    return axios
      .post(url, data)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getReminders(data, animalNumber, search = '') {
    const { page, itemsPerPage } = data;
    let url = `animal/reminder/${animalNumber}?page=${page}&limit=${itemsPerPage}`
    if (search != "") url = `${url}&search=${search}`;
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async animalGeneticsSearch(data, searchData) {
    console.log('search data', data)
    let sarchData = [
      {
        "key": "bw",
        "value": {
          "min": searchData.bw.min, "max": searchData.bw.max, "acc": searchData.bw.acc
        }
      },
      {
        "key": "ww",
        "value": {
          "min": searchData.ww.min, "max": searchData.ww.max, "acc": searchData.ww.acc
        }
      },
      {
        "key": "yw",
        "value": {
          "min": searchData.yw.min, "max": searchData.yw.max, "acc": searchData.yw.acc
        }
      },
      {
        "key": "cw",
        "value": {
          "min": searchData.cw.min, "max": searchData.cw.max, "acc": searchData.cw.acc
        }
      },
      {
        "key": "fat",
        "value": {
          "min": searchData.fat.min, "max": searchData.fat.max, "acc": searchData.fat.acc
        }
      },
      {
        "key": "marb",
        "value": {
          "min": searchData.marb.min, "max": searchData.marb.max, "acc": searchData.marb.acc
        }
      },
      {
        "key": "rea",
        "value": {
          "min": searchData.rea.min, "max": searchData.rea.max, "acc": searchData.rea.acc
        }
      },
      {
        "key": "yg",
        "value": {
          "min": searchData.yg.min, "max": searchData.yg.max, "acc": searchData.yg.acc
        }
      },
      {
        "key": "mk",
        "value": {
          "min": searchData.mk.min, "max": searchData.mk.max, "acc": searchData.mk.acc
        }
      }

    ]
    sarchData = JSON.stringify(sarchData)
    const { page, itemsPerPage, sortBy, sortDesc } = data;
    let url = ``;
    if (searchData.bw.min == null && searchData.bw.max == null && searchData.bw.acc == null &&
      searchData.ww.min == null && searchData.ww.max == null && searchData.ww.acc == null &&
      searchData.yw.min == null && searchData.yw.max == null && searchData.yw.acc == null &&
      searchData.fat.min == null && searchData.fat.max == null && searchData.fat.acc == null &&
      searchData.marb.min == null && searchData.marb.max == null && searchData.marb.acc == null &&
      searchData.rea.min == null && searchData.rea.max == null && searchData.rea.acc == null &&
      searchData.yg.min == null && searchData.yg.max == null && searchData.yg.acc == null &&
      searchData.cw.min == null && searchData.cw.max == null && searchData.cw.acc == null &&
      searchData.mk.min == null && searchData.mk.max == null && searchData.mk.acc == null 
    ) {
      url = `animalGenetics/geneticSearchTool?page=${page}&limit=${itemsPerPage}&gender=${searchData.gender}&breed=${searchData.breed}`
    } else {
      url = `animalGenetics/geneticSearchTool?page=${page}&limit=${itemsPerPage}&gender=${searchData.gender}&breed=${searchData.breed}&searchData=${sarchData}`
      // if(searchData.sortCol){
      //   &sortCol=${searchData.sortCol}&sortOrder=${searchData.sortOrder}`
      // }else{
      //   url = `animalGenetics/geneticSearchTool?page=${page}&limit=${itemsPerPage}&gender=${searchData.gender}&breed=${searchData.breed}&searchData=${sarchData}`
      // }

    }
    if (sortBy?.length > 0 && sortDesc?.length > 0) {
      console.log('sss', sortBy, sortDesc)
      url = `${url}&sortCol=${sortBy[0]}&sortOrder=${sortDesc[0] ? 'DESC' : 'ASC'}`;
    } else if (searchData.sortCol) {
      url = `${url}&sortCol=${searchData.sortCol}&sortOrder=${searchData.sortOrder}`;
    }

    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async animalDropDownBreed() {
    let url = `animalGenetics/getDropdownData/breed`
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async animalDropDownGender() {
    let url = `animalGenetics/getDropdownData/gender`
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async animalGeneticsSearchByReg(data, searchTagData) {

    const { page, itemsPerPage } = data;
    let url = `animalGenetics/search?page=${page}&limit=${itemsPerPage}&gender=${searchTagData.gender}&search=${searchTagData.search}&searchCol=${searchTagData.searchCol}`
    return axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async getAnimalWithGender(gender, data, search = "", currentAnimal = null, farms = []) {
    const { page, itemsPerPage } = data
    let url = `animal/animalswithgender/${gender}?search=${search}&page=${page}&itemsPerPage=${itemsPerPage}`
    if (currentAnimal)
      url = `${url}&currentAnimal=${currentAnimal}`
    return axios[farms.length?'post': 'get'](url, {
      farms
    })
      .then(res => res.data)
      .then(data => Promise.resolve(data))
      .catch(err => Promise.reject(err))
  },

  async getSingleAnimalById(animalId) {
    var url = `animal/detailById/${animalId}`;
    return await axios
      .get(url)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async updateAnimalById(animalData) {
    var url = `animal/updateFromEpd`;
    return axios
      .put(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },

  async deleteAnimalConception(id, type) {
    return await axios.delete(`animal/conception/${id}/${type}`)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },

  async updateAnimalConception(animalData, type='conception') {
    var url = `animal/conception/${type}`;

    return axios
      .put(url, animalData)
      .then(({ data }) => data)
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
};
